import { api } from "./api";

export interface Member {
  id: string;
  user_id: string;
  name: string;
  email: string;
  role: "admin" | "user" | "read_only";
  relationship_label: string | null;
  last_login_at: string | null;
  accepted_at: string;
}

export interface Invitation {
  id: string;
  email: string;
  role: "admin" | "user" | "read_only";
  relationship_label: string | null;
  expires_at: string;
  invited_at: string;
}

export const teamApi = {
  list: () => api.get<{ members: Member[]; invitations: Invitation[] }>("/memberships"),
  invite: (body: { email: string; role: Member["role"]; relationshipLabel?: string }) =>
    api.post<Invitation & { accept_url: string }>("/memberships/invite", body),
  setRole: (id: string, role: Member["role"]) =>
    api.patch<{ id: string; role: Member["role"] }>(`/memberships/${id}`, { role }),
  remove: (id: string) => api.delete<void>(`/memberships/${id}`),
  revokeInvite: (id: string) => api.delete<void>(`/memberships/invitations/${id}`),
};
